import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ToggleDisplay from './../../../components/shared/ToggleDisplay';
import SelectSearchContainer from './../../../components/shared/SelectSearchContainer';
import { copy } from '../../constants';

import {
    Row,
    Col,
    Button,
    FormGroup,
    ControlLabel,
    FormControl,
    HelpBlock,
    Radio
} from 'react-bootstrap';

export class EditUser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            isAdmin: 'true',
            firstName: '',
            lastName: '',
            title: '',
            phone: '',
            phoneExt: '',
            brokerageChangeActive: false,
            currentBrokerage: null,
            newBrokerage: null
        };

        this.handleCancel = this.handleCancel.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChangeBrokerages = this.handleChangeBrokerages.bind(this);
        this.handleBrokerageChange = this.handleBrokerageChange.bind(this);
        this.orderBrokerages = this.orderBrokerages.bind(this);
    }

    componentWillReceiveProps(props) {
        if (props.user) {
            const { user, brokerages, currentBrokerage } = props;
            this.setState({
                email: user.email,
                isAdmin: user.role ? user.role.includes('admin').toString() : 'false',
                firstName: user.firstName,
                lastName: user.lastName,
                title: user.title,
                phone: user.phone,
                phoneExt: user.phoneExt,
                currentBrokerage: currentBrokerage
            });
        }
    }

    handleCancel() {
        this.setState({
            brokerageChangeActive: false
        });
        if (this.props.onCancel) {
            this.props.onCancel();
        }
    }

    handleChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleBrokerageChange(e) {
        const selectedBrokerage = { name: e.label, brokerId: e.value };
        this.setState({
            ...this.state,
            newBrokerage: selectedBrokerage.brokerId
        });
    }

    handleChangeBrokerages() {
        this.setState({
            ...this.state,
            brokerageChangeActive: true
        });
    }

    handleSubmit(e) {
        e.preventDefault();
        if (
            !this.state.firstName ||
            this.state.firstName.length === 0 ||
            !this.state.lastName ||
            this.state.lastName.length === 0 ||
            !this.state.phone ||
            this.state.phone.length === 0
        ) {
            return;
        }

        if (this.props.onSave) {
            this.props.onSave({
                ...this.props.user,
                email: this.state.email,
                role: this.mapRole(this.props.user.role, this.state.isAdmin),
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                title: this.state.title,
                phone: this.state.phone,
                phoneExt: this.state.phoneExt
            });
        }

        if (this.state.newBrokerage !== null) {
            const brokerage = this.props.brokerages.filter(
                b => b.brokerId === this.state.newBrokerage
            )[0];
            this.props.onBrokerageChange(
                {
                    ...this.props.user
                },
                brokerage
            );
        }
    }

    // short-term shim
    mapRole(role, isAdmin) {
        switch (role) {
            case 'regular':
            case 'admin':
            case 'broker:admin':
            case 'broker:regular':
                return isAdmin === 'true' ? 'broker:admin' : 'broker:regular';
            case 'underwriter':
            case 'underwriter:admin':
                return isAdmin === 'true' ? 'underwriter:admin' : 'underwriter:regular';
            default:
                return 'broker:regular';
        }
    }

    renderHelpBlock(text, helpClass) {
        return <HelpBlock className={`${helpClass}`}>{text}</HelpBlock>;
    }

    orderBrokerages(brokerages) {
        return brokerages.filter(b => b.brokerId !== this.props.currentBrokerage.brokerId);
    }

    render() {
        return (
            <div className="editUserModal">
                <p>Email:</p>
                <h4>{this.state.email}</h4>
                <p className="editAdminText">Is user an admin?</p>
                <form onSubmit={this.handleSubmit}>
                    <FormGroup>
                        <br />
                        <Radio
                            name="isAdmin"
                            className="editAdminInput"
                            inline
                            required
                            onChange={this.handleChange}
                            value={'true'}
                            checked={this.state.isAdmin === 'true'}
                            disabled={this.props.adminSelectorDisabled === true}
                        >
                            Yes
                        </Radio>{' '}
                        <Radio
                            name="isAdmin"
                            className="editAdminInput"
                            inline
                            required
                            onChange={this.handleChange}
                            value={'false'}
                            checked={this.state.isAdmin === 'false'}
                            disabled={this.props.adminSelectorDisabled === true}
                        >
                            No
                        </Radio>
                    </FormGroup>

                    <Row>
                        <Col xs={12} sm={8} md={8} lg={10}>
                            <p className="adminEditAddInfo">
                                {copy.lang('brokersEditUserGroupTip', {
                                    brokerageName:
                                        copy.clean(this.props.currentBrokerage.name) || 'Brokerage'
                                })}
                            </p>
                        </Col>
                    </Row>

                    <FormGroup controlId="firstName">
                        <ControlLabel>First Name</ControlLabel>
                        <FormControl
                            id="firstName"
                            name="firstName"
                            type="text"
                            label="Text"
                            value={this.state.firstName}
                            onChange={this.handleChange}
                        />
                        {!this.state.firstName || this.state.firstName.length === 0 ? (
                            this.renderHelpBlock('*Required', 'helpBlockRed')
                        ) : (
                            <div className="completeSpace" />
                        )}
                    </FormGroup>
                    <FormGroup controlId="lastName">
                        <ControlLabel>Last Name</ControlLabel>
                        <FormControl
                            id="lastName"
                            name="lastName"
                            type="text"
                            label="Text"
                            value={this.state.lastName}
                            onChange={this.handleChange}
                        />
                        {!this.state.lastName || this.state.lastName.length === 0 ? (
                            this.renderHelpBlock('*Required', 'helpBlockRed')
                        ) : (
                            <div className="completeSpace" />
                        )}
                    </FormGroup>
                    <FormGroup controlId="title">
                        <ControlLabel>Job Title</ControlLabel>
                        <FormControl
                            id="title"
                            name="title"
                            type="text"
                            label="Text"
                            placeholder="optional"
                            value={this.state.title}
                            onChange={this.handleChange}
                        />
                        <div className="completeSpace" />
                    </FormGroup>
                    <Row>
                        <Col xs={8} sm={8} md={8} lg={8}>
                            <FormGroup controlId="phone">
                                <ControlLabel>Phone Number</ControlLabel>
                                <FormControl
                                    id="phone"
                                    name="phone"
                                    type="text"
                                    label="Text"
                                    value={this.state.phone}
                                    onChange={this.handleChange}
                                />
                                {!this.state.phone || this.state.phone.length === 0 ? (
                                    this.renderHelpBlock('*Required', 'helpBlockRed')
                                ) : (
                                    <div className="completeSpace" />
                                )}
                            </FormGroup>
                        </Col>
                        <Col xs={4} sm={4} md={4} lg={4}>
                            <FormGroup controlId="phoneExt">
                                <ControlLabel>Ext</ControlLabel>
                                <FormControl
                                    id="phoneExt"
                                    name="phoneExt"
                                    type="text"
                                    label="Text"
                                    placeholder="optional"
                                    value={this.state.phoneExt}
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <ToggleDisplay
                        show={this.state.brokerageChangeActive}
                        render={() => (
                            <Row>
                                <Col xs={12} sm={12} md={12} lg={12}>
                                    <FormGroup
                                        controlId="brokerageChange"
                                        className="adminEditAddInfo"
                                    >
                                        <ControlLabel>
                                            Move the user account to the following brokerage office
                                            <br />
                                            <span className="greyLabel">
                                                Current brokerage is:{' '}
                                                <strong>{this.props.currentBrokerage.name}</strong>
                                            </span>
                                        </ControlLabel>

                                        <Row>
                                            <Col xs={12} sm={8} md={8} lg={10}>
                                                <div className="box-warning">
                                                    {copy.lang(
                                                        'brokersEditBrokerageChangeWarning',
                                                        {
                                                            brokerageName:
                                                                copy.clean(
                                                                    this.props.currentBrokerage.name
                                                                ) || 'Brokerage'
                                                        }
                                                    )}
                                                </div>
                                            </Col>
                                        </Row>

                                        <SelectSearchContainer
                                            options={this.orderBrokerages(this.props.brokerages)}
                                            labelColumn={'name'}
                                            valueColumn={'brokerId'}
                                            value={this.state.newBrokerage}
                                            onChange={this.handleBrokerageChange}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                        )}
                    />
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12}>
                            <div>
                                <Button className="saveEditChanges" type="submit">
                                    Save Changes
                                </Button>
                                <ToggleDisplay
                                    hide={this.state.brokerageChangeActive}
                                    render={() => (
                                        <Button
                                            className="saveEditChanges"
                                            onClick={this.handleChangeBrokerages}
                                        >
                                            Change Brokerage Office
                                        </Button>
                                    )}
                                />
                                <Button
                                    className="cancelEdit secondary"
                                    onClick={this.handleCancel}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </form>
            </div>
        );
    }
}

EditUser.propTypes = {
    user: PropTypes.object.isRequired,
    onSave: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    adminSelectorDisabled: PropTypes.bool
};
